module.exports = __webpack_public_path__ + "img/audio.29ac5db1.svg";